const blogPost = {
  blogBy: 'Blog written by',
  coverImage_pictureBy: 'Picture by',
  coverImage_on: 'on',
  ogType: 'article',
}

export default blogPost
